import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useRepositoryQuery, GuestLedgerTableRecord, GuestLedgerOrderBy } from '@mews-commander/data-access';
import { TableState } from '@optimus-web/core';
import { useGuestLedgerFilterContext, useGuestLedgerSelectedDate } from '../context/GuestLedgerFilterContext';
import { transformFilterValues } from '../../common/utils/transformFilterValues';

export const useGuestLedgerTableQuery = ({ globalFilters, pagination, sort }: TableState<GuestLedgerTableRecord>) => {
    const enterpriseId = useCurrentEnterpriseId();
    const { filterValues } = useGuestLedgerFilterContext();
    const { selectedDate } = useGuestLedgerSelectedDate();
    const { search: searchField } = globalFilters;
    const [columnKey, columnValue] = Object.entries(sort ?? {})[0] || [];
    const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
    const orderBy = columnKey ? (capitalize(columnKey) as GuestLedgerOrderBy) : undefined;
    const filterValuesToSubmit = transformFilterValues(filterValues);

    return useRepositoryQuery(
        'guestLedger',
        'getAll',
        {
            enterpriseId,
            ...filterValuesToSubmit,
            date: selectedDate,
            searchField,
            count: pagination.pageSize,
            startIndex: pagination.pageIndex * pagination.pageSize,
            orderBy,
            order: columnValue?.order,
        },
        {
            enabled: !!enterpriseId,
            staleTime: 5000,
            refetchOnWindowFocus: true,
            refetchOnMount: true,
            refetchInterval: 60000,
            select: (data) => ({
                data: data?.data?.map((row) => ({
                    ...row,
                    id: `${row.ownerId}.${row.billId ?? 'unpaid'}`,
                })),
                totalRowCount: data?.totalRowCount,
            }),
        }
    );
};
